import { render } from "./Manage.vue?vue&type=template&id=99c7d41a&scoped=true"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"

import "./Manage.vue?vue&type=style&index=0&id=99c7d41a&scoped=true&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-99c7d41a"]])

export default __exports__